<template>
  <v-app id="app">
    <component @selectedCommercial="rechargeComponent" :is="layout"> </component>
    <v-main>
      <v-container id="route" fluid class="px-0" :key="index" :class="{'login':$route.name == 'login'}">
        <router-view />
      </v-container>
    </v-main>
    <v-snackbar
      v-model="$store.state.notification.show"
      :color="$store.state.notification.type === 'success' ? '#2e7d32' : '#c62828'"
      top
      right
      :timeout="4000"
      min-width="320"
      @input="$store.commit('clearNotification')"
    >
      <div class="d-flex align-center py-1">
        <v-icon class="mr-3" size="22">
          {{ $store.state.notification.type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
        </v-icon>
        <span class="font-weight-medium" style="font-size: 1rem;">{{ $store.state.notification.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="$store.commit('clearNotification')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
const defautl_layout = "default";
export default {
  name: "App",
  computed: {
    layout() {
      if (
        this.$store.state.user.Role &&
        this.$store.state.user.Role.id_role == 1 &&
        this.$route.meta.layout != "no"
      ) {
        return (this.$route.meta.layout || defautl_layout) + "-admin-layout";
      } else {
        return (this.$route.meta.layout || defautl_layout) + "-layout";
      }
    },
   
    

  },
  methods :{
     rechargeComponent:function(){
      return this.index +=1;
     
    }
  },
  data(){
    return {
       index:0

    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@700&display=swap");
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.v-main,#route{
    height: 87vh;
  }
   #route.login{
    padding: 0;
  }
@media screen and (max-width: 1366px) {
  #app {
    font-size: 14px;
  }
  
}
 
</style>
